export const MAIL_DOMAINS_ERROR_CODES = {
  sendingDomainIsInUse: 'error.settings.sendingDomainIsInUse',
};
